// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1lntg","rootSuccess":"CompleteLink_rootSuccess__1bT_d","rootFailure":"CompleteLink_rootFailure__3UHUU","isDisabled":"CompleteLink_isDisabled__kOPnW"};